import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import ViewRow from './ViewRow';

const View = (props: any) => {
  return <TableContainer
  component={Paper}
  sx={{
    boxShadow: 'none',
    width: '100%',
    height: '100%',
  }}
>
  <Table
    sx={{
      minWidth: 470,
      '& .MuiTableCell-root.MuiTableCell-head': {
        borderBottom: '1px solid #F3F3F3',
        fontWeight: 700,
        p: '6px 16px',
        fontSize: '14px',
      },
      '& .MuiTableCell-root.MuiTableCell-body': {
        color: 'primary.dark',
        fontSize: '14px',
        py: '6px',
      },
    }}
    aria-label='simple table'
  >
    <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
      <ViewRow
        title='氏名'
        content={props.user ? props.user.fullname : ''}
      />
      <ViewRow
        title='ログイン名'
        content={props.user ? props.user.username : ''}
      />
      <ViewRow
        title='職種'
        content={props.user ? props.user.role : ''}
      />
      <ViewRow
        title='管理者'
        content={props.user ? (props.user.isadmin === 1 ? '✓' : '') : ''}
      />
      <ViewRow
        title='備考'
        content={props.user ? props.user.alias : ''}
      />
      <ViewRow
        title='表示順位'
        content={props.user ? props.user.displayorder : ''}
      />
      <ViewRow
        title='最終ログイン'
        content={props.user ? props.user.lastlogintime : ''}
      />
      <ViewRow
        title='ステータス'
        content={props.user ? (props.user.status === 1 ? '有効' : '無効') : ''}
      />
    </TableBody>
  </Table>
</TableContainer>;
};

export default View;
